// @flow

import Form from './Form';

import type { Rules, FieldLabels, Values, ErrorMessages } from '../types/form';

export type AddressFormInput = {
  city?: string;
  country?: string;
  postal_code?: string;
  province?: string;
  street_address?: string;
}

export default class AddressForm extends Form {
  get keys(): Array<string> {
    return [
      'street_address',
      'province',
      'postal_code',
      'city'
    ];
  }

  get values() : Values {
    return Object.assign({}, super.values, {
      country: 'Canada'
    });
  }

  get rules(): Rules {
    return {
      city: (input) => input.length >= 2,
      province: (input) => input.length >= 2,
      street_address: (input) => input.length > 4,
      postal_code: (input) => /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/.test(input)
    };
  }

  translatedValue = (key: String) => (this.getTranslatedValue('addressForm', key))

  get errorMessages(): ErrorMessages {
    return {
      postal_code: this.translatedValue('errors.postal_code'),
      province: this.translatedValue('errors.province'),
      street_address: this.translatedValue('errors.street_addr'),
      city: this.translatedValue('errors.city')
    };
  }

  get fieldLabels(): FieldLabels {
    return {
      postal_code: this.translatedValue('lower.postal_code'),
      province: this.translatedValue('lower.province'),
      street_address: this.translatedValue('lower.street_addr'),
      city: this.translatedValue('lower.city')
    };
  }
}


// WEBPACK FOOTER //
// ./src/models/AddressForm.js